import { Link } from "react-router-dom";
import "./Home.css";
const Home = () => {
  return (
    <section className="hero-section">
      <div className="hero-details-container">
        <h1>
          Verify Your Publication Title with <span>PRISM</span>
        </h1>
        <p>Ensure your title meets uniqueness & compliance.</p>
        <Link to="/submit-title">
          <button>Get Verified Now</button>
        </Link>
      </div>
      <div className="hero-image-container">
        <img
          className="hero-image"
          src="./hero-bg-img 1.png"
          alt="hero-image"
        />
      </div>
    </section>
  );
};

export default Home;
